import axios from 'axios';

import { City, IGeoApiCity } from '@/types/models/City';
import { MATCH_POSTAL_CODE } from '@/constants/regex';
import { Department } from '@/types/Department';

/**
 * Service pour les appels API des villes.
 */
export class AddressApiService {

	/**
	 * Récupère 10 villes qui correspondent à la recherche
	 * @param value le nom ou code postal partiel de la ville
	 */
	public static getCityListByNameOrDepartment(value: string): Promise<City[]> {
		const queryParam = MATCH_POSTAL_CODE.test(value) ? `postalCode=${value}` : `name=${value}`;

		return axios.get<IGeoApiCity[]>(`addresses/search-cities?${queryParam}`)
			.then(res => res.data.map(c => new City({
				code: c.code,
				name: c.nom,
				postal_codes: c.codesPostaux,
				department: c.departement.nom,
				coordinates_x: c.centre.coordinates[0],
				coordinates_y: c.centre.coordinates[1]
			})))
			.catch(() => []);
	}

	/**
	 * Récupère la liste des départements
	 */
	public static getDepartmentList(): Promise<Department[]> {
		return axios.get<Department[]>('addresses/search-departments')
			.then(res => res.data)
			.catch(() => []);
	}
}
